export default "__VITE_ASSET__1c169553__"